import { useEffect } from "react";
import { Link } from "react-router-dom";
import "./Legal.css";
import Layout from "@/components/Layout";
import SEO from "@/components/SEO";

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Layout>
      <SEO 
        title="Privacy Policy"
        description="IntentLogic Privacy Policy - Learn how we collect, use, and protect your personal information. We are committed to maintaining the security and privacy of your data."
        keywords="privacy policy, data protection, personal information, data security, CCPA, privacy rights, data collection"
        canonical="/privacy-policy"
      />
      <main className="legal-content">
        <div className="legal-container">
          <span className="legal-label">INTENTLOGIC</span>
          <h1>Privacy Policy</h1>
          <p className="legal-updated">Last Updated: December 2025</p>
          
          <div className="legal-text">
            <p>
              Thank you for visiting the IntentLogic website located at www.intentlogic.com (the "Site"). 
              The Site is an Internet property of IntentLogic ("IntentLogic," "we," "our" or "us"). We respect 
              the privacy of each visitor to our Site ("user," "you" or "your") and are committed to protecting 
              the security of any information that we collect from you. The following Privacy Policy describes 
              the types of information we may collect, how we collect it and what we do with that information.
            </p>
            
            <p>
              This Privacy Policy does not apply to any other websites or to information that may be collected 
              by any other websites. Additionally, we are not responsible for, and this Privacy Policy does not 
              apply to, the privacy practices of other companies or other websites, such as, but not limited to, 
              third-party social media websites like Facebook, LinkedIn, Instagram, Twitter (collectively, 
              "Social Media Websites") which you may access through your use of this Site. We encourage you to 
              seek out and read the privacy policy of each website that you visit.
            </p>
            
            <h2>What information do we collect, and how do we collect it?</h2>
            <p>
              We may collect personal information from you that you provide voluntarily after clicking the 
              submission button on the applicable contact form on our Site. This information may include, 
              without limitation, your: (i) full name; (ii) e-mail address; (iii) telephone number; and 
              (iv) any and all other information requested (collectively, "Contact Data"). As with many other 
              websites, the web servers used to operate our Site may also automatically collect certain data 
              pertaining to you, including your location, computer operating system, Internet Protocol (IP) 
              address, access times, browser type and language, and the website you visited before or after 
              visiting our Site.
            </p>
            
            <h2>What we do with the information we collect?</h2>
            <p>
              We use the personal information we collect to contact you with information about IntentLogic and 
              our services. We will not rent or sell your personal information, though we may share it with our 
              subsidiaries and companies that are affiliated with us.
            </p>
            
            <h2>Children under the age of 18</h2>
            <p>
              We are committed to protecting the privacy of visitors under the age of 18. We do not knowingly 
              collect personal information from children under the age of 18. If we learn we have collected or 
              received personal information from a child under the age of 18 without verification or parental 
              consent, we will delete that information. If you believe we might have any personal information 
              from or about a child under the age of 18, please contact us at the contact information provided below.
            </p>
            
            <h2>Security of your information</h2>
            <p>
              We maintain physical, electronic and procedural safeguards designed to protect the information we 
              collect from you. We limit access to personal information to authorized personnel who need access 
              to perform their job and are contractually required to keep your information secure. However, due 
              to the nature of the Internet, we cannot guarantee that your information will not be obtained by 
              someone without our authorization. If you become aware of any breach of Site security, this Privacy 
              Policy, or the Terms and Conditions, please notify us immediately.
            </p>
            
            <h2>Privacy rights requests</h2>
            <p>
              You have the right to access, know, correct, obtain, and/or request deletion of data that IntentLogic 
              maintains regarding you. IntentLogic shall evaluate all such requests, and either grant or deny the 
              request. If your request is denied, you have the right to proceed through IntentLogic's appeals process. 
              If you wish to exercise any of your rights, please contact us at the contact information provided below.
            </p>
            
            <h2>Any privacy related questions or comments?</h2>
            <p>Please contact us at:</p>
            
            <div className="legal-contact">
              <p><strong>IntentLogic</strong></p>
              <p>Attn: Compliance Department</p>
              <p>Metro Office Park</p>
              <p>14 Calle 2 102</p>
              <p>Guaynabo, Puerto Rico 00968</p>
              <p>Telephone: 855-948-4423</p>
            </div>
          </div>
        </div>
      </main>
    </Layout>
  );
};

export default PrivacyPolicy;
